import { render, staticRenderFns } from "./JdiPreview.vue?vue&type=template&id=387ebbbd&scoped=true&"
import script from "./JdiPreview.vue?vue&type=script&lang=ts&"
export * from "./JdiPreview.vue?vue&type=script&lang=ts&"
import style0 from "./JdiPreview.vue?vue&type=style&index=0&id=387ebbbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387ebbbd",
  null
  
)

export default component.exports